/**
 * HOS API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * Contact: info@hos.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Injector, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';
import {HosBaseService} from "./hos-base.service";

import { Observable }                                        from 'rxjs';

import { Album } from '../model/album';
import { RatingRequestBody } from '../model/ratingRequestBody';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class AlbumService extends HosBaseService {

    // protected basePath = 'https://localhost';
    // public defaultHeaders = new HttpHeaders();
    // public configuration = new Configuration();

    /*constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }*/

    constructor(injector: Injector) {
        super(injector);
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    /*private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }*/


    /**
     * Return the album detail
     * 
     * @param albumId The album id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAlbumDetail(albumId: number, observe?: 'body', reportProgress?: boolean): Observable<Album>;
    public getAlbumDetail(albumId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Album>>;
    public getAlbumDetail(albumId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Album>>;
    public getAlbumDetail(albumId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (albumId === null || albumId === undefined) {
            throw new Error('Required parameter albumId was null or undefined when calling getAlbumDetail.');
        }

        let headers = this.getDefaultHeaders();

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = undefined; // this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Album>(`${this.getBasePath()}/api/v1/albums/${encodeURIComponent(String(albumId))}`,
            {
                // withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Return the prev/next albums
     * 
     * @param albumId The album id
     * @param position The current position
     * @param filterBy The filter by type
     * @param filterValue The filter value
     * @param orderBy The Order by field
     * @param body The Order by direction
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAlbumsPrevNext(albumId: number, position: number, filterBy?: 'recent' | 'popular' | 'genre', filterValue?: string, orderBy?: 'title' | 'artists' | 'date' | 'popularity', body?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<Album>>;
    public getAlbumsPrevNext(albumId: number, position: number, filterBy?: 'recent' | 'popular' | 'genre', filterValue?: string, orderBy?: 'title' | 'artists' | 'date' | 'popularity', body?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<Album>>>;
    public getAlbumsPrevNext(albumId: number, position: number, filterBy?: 'recent' | 'popular' | 'genre', filterValue?: string, orderBy?: 'title' | 'artists' | 'date' | 'popularity', body?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<Album>>>;
    public getAlbumsPrevNext(albumId: number, position: number, filterBy?: 'recent' | 'popular' | 'genre', filterValue?: string, orderBy?: 'title' | 'artists' | 'date' | 'popularity', body?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (albumId === null || albumId === undefined) {
            throw new Error('Required parameter albumId was null or undefined when calling getAlbumsPrevNext.');
        }

        if (position === null || position === undefined) {
            throw new Error('Required parameter position was null or undefined when calling getAlbumsPrevNext.');
        }





        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (filterBy !== undefined && filterBy !== null) {
            queryParameters = queryParameters.set('filterBy', <any>filterBy);
        }
        if (filterValue !== undefined && filterValue !== null) {
            queryParameters = queryParameters.set('filterValue', <any>filterValue);
        }
        if (orderBy !== undefined && orderBy !== null) {
            queryParameters = queryParameters.set('orderBy', <any>orderBy);
        }
        if (position !== undefined && position !== null) {
            queryParameters = queryParameters.set('position', <any>position);
        }

        let headers = this.getDefaultHeaders();

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = undefined; // this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];
        const httpContentTypeSelected: string | undefined = undefined; // this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.get<Array<Album>>(`${this.getBasePath()}/api/v1/albums/${encodeURIComponent(String(albumId))}/prev-next`,
            {
                params: queryParameters,
                // withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Return the albums
     * 
     * @param includeTrackArtists Include track artists
     * @param filterBy The filter by type
     * @param filterValue The filter value
     * @param orderBy The Order by field
     * @param body The Order by direction
     * @param page The current page
     * @param size The size of the page
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAlbumsV3(includeTrackArtists: boolean, filterBy?: 'recent' | 'popular' | 'genre', filterValue?: string, orderBy?: 'title' | 'artists' | 'date' | 'popularity', body?: string, page?: number, size?: number, observe?: 'body', reportProgress?: boolean): Observable<Array<Album>>;
    public getAlbumsV3(includeTrackArtists: boolean, filterBy?: 'recent' | 'popular' | 'genre', filterValue?: string, orderBy?: 'title' | 'artists' | 'date' | 'popularity', body?: string, page?: number, size?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<Album>>>;
    public getAlbumsV3(includeTrackArtists: boolean, filterBy?: 'recent' | 'popular' | 'genre', filterValue?: string, orderBy?: 'title' | 'artists' | 'date' | 'popularity', body?: string, page?: number, size?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<Album>>>;
    public getAlbumsV3(includeTrackArtists: boolean, filterBy?: 'recent' | 'popular' | 'genre', filterValue?: string, orderBy?: 'title' | 'artists' | 'date' | 'popularity', body?: string, page?: number, size?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (includeTrackArtists === null || includeTrackArtists === undefined) {
            throw new Error('Required parameter includeTrackArtists was null or undefined when calling getAlbumsV3.');
        }







        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (filterBy !== undefined && filterBy !== null) {
            queryParameters = queryParameters.set('filterBy', <any>filterBy);
        }
        if (filterValue !== undefined && filterValue !== null) {
            queryParameters = queryParameters.set('filterValue', <any>filterValue);
        }
        if (orderBy !== undefined && orderBy !== null) {
            queryParameters = queryParameters.set('orderBy', <any>orderBy);
        }
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', <any>page);
        }
        if (size !== undefined && size !== null) {
            queryParameters = queryParameters.set('size', <any>size);
        }
        if (includeTrackArtists !== undefined && includeTrackArtists !== null) {
            queryParameters = queryParameters.set('includeTrackArtists', <any>includeTrackArtists);
        }

        let headers = this.getDefaultHeaders();

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = undefined; // this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];
        const httpContentTypeSelected: string | undefined = undefined; // this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.get<Array<Album>>(`${this.getBasePath()}/api/v1/albums`,
            {
                params: queryParameters,
                // withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Mark the album as blocked
     * 
     * @param albumId The album id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public markBlocked(albumId: number, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public markBlocked(albumId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public markBlocked(albumId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public markBlocked(albumId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (albumId === null || albumId === undefined) {
            throw new Error('Required parameter albumId was null or undefined when calling markBlocked.');
        }

        let headers = this.getDefaultHeaders();

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = undefined; // this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.put<any>(`${this.getBasePath()}/api/v1/albums/${encodeURIComponent(String(albumId))}/block`,
            null,
            {
                // withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Mark the album as favorite
     * 
     * @param albumId The album id
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public markFavorite(albumId: number, body?: RatingRequestBody, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public markFavorite(albumId: number, body?: RatingRequestBody, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public markFavorite(albumId: number, body?: RatingRequestBody, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public markFavorite(albumId: number, body?: RatingRequestBody, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (albumId === null || albumId === undefined) {
            throw new Error('Required parameter albumId was null or undefined when calling markFavorite.');
        }


        let headers = this.getDefaultHeaders();

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = undefined; // this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];
        const httpContentTypeSelected: string | undefined = undefined; // this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<any>(`${this.getBasePath()}/api/v1/albums/${encodeURIComponent(String(albumId))}/favorite`,
            body,
            {
                // withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Mark the album as unblocked
     * 
     * @param albumId The album id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public unmarkBlocked(albumId: number, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public unmarkBlocked(albumId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public unmarkBlocked(albumId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public unmarkBlocked(albumId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (albumId === null || albumId === undefined) {
            throw new Error('Required parameter albumId was null or undefined when calling unmarkBlocked.');
        }

        let headers = this.getDefaultHeaders();

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = undefined; // this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<any>(`${this.getBasePath()}/api/v1/albums/${encodeURIComponent(String(albumId))}/block`,
            {
                // withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Unmark the album as favorite
     * 
     * @param albumId The album id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public unmarkFavorite(albumId: number, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public unmarkFavorite(albumId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public unmarkFavorite(albumId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public unmarkFavorite(albumId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (albumId === null || albumId === undefined) {
            throw new Error('Required parameter albumId was null or undefined when calling unmarkFavorite.');
        }

        let headers = this.getDefaultHeaders();

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = undefined; // this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<any>(`${this.getBasePath()}/api/v1/albums/${encodeURIComponent(String(albumId))}/favorite`,
            {
                // withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
